<template>
  <div class="purchase">
    <div v-if="!pupopShow" style="width: 95%; margin: auto">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            v-model="bgform.param"
            style="display: flex"
            label-position="right"
            label-width="90px"
          >
            <el-form-item label="调剂证编号:" label-width="90px">
              <el-input
                v-model="bgform.param.tjzBhLike"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="化学品:" label-width="90px">
              <el-input
                v-model="bgform.param.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="入库日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="bgform.param.beginRkrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="bgform.param.endRkrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="bgform.param.zt" placeholder="">
                <el-option
                  v-for="item in zhuangtaixiala"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              class="chongzhiButton"
              size="small"
              icon="el-icon-refresh-right"
              round
              @click="hchongzhi"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            :header-cell-class-name="cellClass"
            @selection-change="handleSelectionChange"
            @select-all="checkSelect"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  style="border: none"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addPupShow(0)"
                >新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-plus"
                  @click="addPupShow(1)"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="hdaochu"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />
              <template v-for="(item, i) in table">
                <el-table-column
                  v-if="item.label !== '状态'"
                  :key="i"
                  :show-overflow-tooltip="true"
                  align="center"
                  :label="item.label"
                  :width="item.key == 'ckmc' ? '180' : ''"
                >
                  <template slot-scope="scope">
                    <span :title="scope.row[item.key]">
                      {{ scope.row[item.key] }}
                    </span>
                  </template>
                </el-table-column>
              </template>
              <el-table-column align="center" prop="bgcs" label="变更次数">
                <template slot-scope="scope">
                  <span
                    v-preventReClick
                    style="cursor: pointer"
                    @click="bgcsClick(scope.row)"
                  >{{ scope.row.bgcs }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :show-overflow-tooltip="true"
                prop="zt"
                label="状态"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.zt == '00'"
                    style="color: #000; font-weight: bold"
                  >草稿</span>
                  <span
                    v-if="scope.row.zt == '01'"
                    style="color: #6fc89a; font-weight: bold"
                  >已入库</span>
                  <span
                    v-if="scope.row.zt == '11'"
                    style="color: #43a5e2; font-weight: bold"
                  >入库变更中</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="addPupShow(2, scope.row.id,scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow(3, scope.row.id)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="hshanchu(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow(4, scope.row.id,scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="bgform.size"
            class="el-page"
            :current-page="currentpage"
            @size-change="pagesizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <tjhcRkDialog
      v-if="pupopShow"
      ref="tjhcRkDialog"
      :djsjshow="djsjshow"
      :bgdisable="bgdisable"
      :ckdisable="ckdisable"
      :xkz-bh="xkzBh"
    />
  </div>
</template>
<script>
import tjhcRkDialog from '@/components/tjhc/tjhcRkDialog'
import bgcs from '@/components/bgcs'
import {
  APIGMzhuangtai // 状态下拉
} from '@/assets/js/wangshuai.js'
import { getTJRKList, deleteTJRK, excelwriter } from '@/assets/js/tjhcrk.js'
export default {
  components: { tjhcRkDialog, bgcs },
  props: {},
  data() {
    return {
      bgcsTKName: '调剂入库',
      startTime: {
        disabledDate: (time) => {
          if (this.bgform.param.endRkrq) {
            return (
              time.getTime() > new Date(this.bgform.param.endRkrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.bgform.param.beginRkrq) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.bgform.param.beginRkrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      // 搜素表格
      bgform: {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          tjzBhLike: '',
          beginRkrq: '',
          endRkrq: '',
          zt: ''
        }
      },
      // 是否显示登记射时间
      djsjshow: true,
      // 变更无法修改的字段
      bgdisable: true,
      // 查看显示无法修改
      ckdisable: true,
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      pupopShow: false,
      searchForm: [],
      table: [
        {
          key: 'rkbh',
          label: '入库编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'tjzBh',
          label: '调剂证编号'
        },
        {
          key: 'yszBh',
          label: '运输证编号'
        },
        {
          key: 'ckmc',
          label: '仓库名称'
        },
        {
          key: 'rksl',
          label: '入库数量'
        },
        {
          key: 'rkrq',
          label: '入库日期'
        },
        {
          key: 'djsj',
          label: '登记日期'
        },
        {
          key: 'zt',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      multipleSelection: [],

      zhuangtaixiala: [], // 状态下拉
      currentpage: 0,
      xkzBh: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.params.zjlx) {
      this.$nextTick(() => {
        this.addPupShow(3, this.$route.params.id)
      })
    }
    if (this.$route.params.xkzBh) {
      this.$nextTick(() => {
        this.xkzBh = this.$route.params.xkzBh
        this.addPupShow(0)
      })
    }
  },
  mounted() {
    this.htableDataList()
    // 搜索下拉状态
    APIGMzhuangtai().then((res) => {
      this.zhuangtaixiala = res.data.data
    })
  },

  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '20')
      this.bgwindow = curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 导出
    hdaochu() {
      excelwriter(this.bgform).then((res) => {
        const table = '调剂入库'
        const a = document.createElement('a')
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },

    // 删除
    hshanchu(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTJRK(id).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.htableDataList()
        })
      })
    },
    // 重置
    hchongzhi() {
      this.bgform.page = 1
      this.bgform.size = 10
      this.bgform.param.hxpMc = ''
      this.bgform.param.tjzBhLike = ''
      this.bgform.param.beginRkrq = ''
      this.bgform.param.endRkrq = ''
      this.bgform.param.zt = ''

      this.htableDataList()
    },
    // 内部分页方法
    pagesizeChange(val) {
      this.bgform.size = val
      this.htableDataList()
    },
    handleCurrentChange(val) {
      this.bgform.page = val
      this.htableDataList()
    },
    // 获取列表数据
    htableDataList() {
      getTJRKList(this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
        this.tableData.forEach((item) => {
          item.rksl = item.rksl + item.rkslDwLabel
        })
      })
    },

    // 复选框单选择
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.cktable.clearSelection()
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    //
    addPupShow(type, id, row) {
      this.pupopShow = true

      if (type == 0) {
        // 新增
        this.djsjshow = false
        this.bgdisable = false
        this.ckdisable = false
      } else if (type == 1) {
        // 复制新增
        this.djsjshow = false
        this.bgdisable = false
        this.ckdisable = false

        if (this.multipleSelection.length == 0) {
          this.pupopShow = false
          this.$message.error('请勾选要复制新增的列表内容')
          return
        }
        setTimeout(() => {
          this.$refs.tjhcRkDialog.hxqsjFZ(this.multipleSelection[0].id)
        }, 30)
      } else if (type == 2) {
        // 查看
        this.djsjshow = true
        this.bgdisable = false
        this.ckdisable = true
        setTimeout(() => {
          this.$refs.tjhcRkDialog.hxqsj(id)
        }, 30)
        this.$bus.emit('fatherToChil', row, '1')
      } else if (type == 3) {
        // 编辑
        this.djsjshow = true
        this.bgdisable = false
        this.ckdisable = false
        setTimeout(() => {
          this.$refs.tjhcRkDialog.hxqsj(id)
        }, 30)
      } else if (type == 4) {
        // 变更
        this.djsjshow = true
        this.bgdisable = true
        this.ckdisable = false
        setTimeout(() => {
          this.$refs.tjhcRkDialog.hxqsj(id)
        }, 30)
        this.$bus.emit('fatherToChil', row, '1')
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '已入库':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '变更审批中':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '草稿':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>
<style scoped lang='less'>
.sousuoButton {
  width: 90px;
  height: 39px;
  background: #4170ff;
  border-color: #4170ff;
}
.chongzhiButton {
  width: 90px;
  height: 39px;
}
.purchase {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  /deep/.el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 32px;
    width: 30px !important;
    color: #303133;
  }
  // height: 100%;
  .headerSearch {
    max-width: 1518px;

    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        // width: 90px;
        // height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    // .el-button--warning {
    //   color: #fff;
    //   background: #fe5622;
    //   border-radius: 3px;
    //   border-color: #fe5622;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
